import { Link, NavLink } from 'react-router-dom';
import clsx from 'clsx';
import { useIntegrationsHealth, useStudioTeam } from '@/api/studio';
import { QueryPending } from '@/components/QueryState';
import { Empty, PageHeader } from '@/components/ui';
import { studioCan } from '@/lib/access';
import { IntegrationsHealth } from './IntegrationsHealth';

const TABS = [
  { to: '/studio/admin/audit', label: 'Журнал действий' },
  { to: '/studio/admin/integrations', label: 'Интеграции' },
];

/** The pages of «Администрирование», one row of tabs over each. */
export function AdminTabs() {
  return (
    <nav className="-mt-4 mb-8 flex gap-1 border-b border-line" aria-label="Администрирование">
      {TABS.map((t) => (
        <NavLink
          key={t.to}
          to={t.to}
          className={({ isActive }) => clsx('-mb-px border-b-2 px-3 pb-2 text-sm', isActive ? 'border-ink font-medium text-ink' : 'border-transparent text-muted hover:text-ink')}
        >
          {t.label}
        </NavLink>
      ))}
    </nav>
  );
}

/** Администрирование → Интеграции: which dependencies work and when each last did. Owners only. */
export function StudioIntegrations() {
  const team = useStudioTeam();
  const me = team.data?.[0];
  if (!me) return <QueryPending query={team} />;
  if (!studioCan(me.studioRole, 'team')) return <Empty title="Раздел для владельцев студии">Состояние интеграций смотрит владелец студии.</Empty>;
  return (
    <>
      <PageHeader title="Интеграции" description="Invoice Ninja, Linear, почта, платежи и остальное, от чего зависит кабинет: работает ли и когда отвечало в последний раз." />
      <AdminTabs />
      <IntegrationsHealth />
    </>
  );
}

/** On the studio's main page: one line, and only when something does not answer. The list lives in Администрирование. */
export function IntegrationsAlert() {
  const { data } = useIntegrationsHealth(true);
  const failing = data?.dependencies.filter((d) => d.status === 'failing') ?? [];
  if (!failing.length) return null;
  return (
    <p className="mb-8 rounded-lg px-4 py-3 text-sm shadow-hair">
      <span className="mr-2 inline-block size-2 rounded-full bg-overdue align-middle" aria-hidden />
      Не отвечает: {failing.map((d) => d.name).join(', ')}.{' '}
      <Link className="underline underline-offset-2" to="/studio/admin/integrations">
        Подробнее
      </Link>
    </p>
  );
}
